"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFunction = exports.Converter = void 0;
const Model_1 = require("./Model");
/**
 *
 * Create a converter object for use with Firestore.  This can be used
 * directly via
 * {@linkcode https://firebase.google.com/docs/reference/js/firebase.firestore.FirestoreDataConverter | withConverter}
 * and will automatically handle the (de)serializtion to/from firestore.
 *
 * @param model {@linkcode Model} to create converter for
 * @param options Options to configure loading and validation behavior
 *
 */
const Converter = (model, options) => {
    const opts = Object.assign({ safeMode: true }, options);
    return {
        fromFirestore: (snap) => {
            return model.raw(snap.data(), opts);
        },
        toFirestore: (data) => {
            return Model_1.serialize(data, options === null || options === void 0 ? void 0 : options.transformOpts);
        },
    };
};
exports.Converter = Converter;
/**
 *
 * Create a callable function linked to a Cloud Function with automatic
 * validation and serialization of the request and response objects.
 *
 * @param functions Firebase Functions instance
 * @param name Name of the function as deployed to Cloud Functions
 * @param req Request {@linkcode Model}
 * @param res Response {@linkcode Model}
 * @typeParam R Type of the request {@linkcode Model}
 * @typeParam T Type of the response {@linkcode Model}
 */
function createFunction(functions, name, req, res) {
    const callable = functions.httpsCallable(name);
    return (data, options = {}) => __awaiter(this, void 0, void 0, function* () {
        let inst = data;
        if ((data === null || data === void 0 ? void 0 : data.constructor) === Object) {
            // We were passed a plain object so we'll transform it before
            // sending to the cloud function
            const opts = Object.assign({ 
                // Don't throw the validation error client side--let the
                // server handle it.
                silent: true }, options);
            inst = req.raw(data, opts);
        }
        const response = {
            result: undefined,
        };
        try {
            const result = yield callable(inst);
            try {
                response.result = res.raw(result.data, options);
            }
            catch (error) {
                response.error = error;
            }
        }
        catch (error) {
            // TODO: This error actually isn't guarenteed to be an HttpsError because
            // the call to raw() could potentially throw a ValidationError.
            response.error = error;
        }
        return response;
    });
}
exports.createFunction = createFunction;
//# sourceMappingURL=Firebase.js.map